import React, { useContext } from 'react';
import { AccordionContext } from './AccordionContext';
import './HeadlessAccordion.scss';

export type Props = {
  children: React.ReactNode;
  trigerId: string;
  panelId: string;
};
const Panel = ({
  children,
  trigerId = 'accordion1id',
  panelId = 'sect1',
}: Props) => {
  const { expanded } = useContext(AccordionContext);

  return (
    <div
      id={panelId}
      role="region"
      aria-labelledby={trigerId}
      className={`accordion-panel ${expanded ? 'expanded' : 'collapsed'}`}
      hidden={!expanded}
      data-testid="headles-accordion-panel-testid"
    >
      {children}
    </div>
  );
};

export default Panel;
